<template>
  <div>
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>luminoso 2c</title>
      <path fill="#679940"
        d="M25.39,4H22.52V2a1,1,0,0,0-1-1H6.61a1,1,0,0,0-1,1V23a1,1,0,0,0,1,1H8.3l3.76,5h-2a1,1,0,0,0,0,2h12a1,1,0,0,0,0-2h-2l3.76-5h1.56a1,1,0,0,0,1-1V5A1,1,0,0,0,25.39,4ZM16.07,29l3.76-5h1.5l-3.76,5ZM7.61,3H20.52V22H7.61Zm5,21h4.72l-3.26,4.34L10.8,24Zm11.78-2H22.52V6h1.87Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "Luminoso2c"
};
</script>


// WEBPACK FOOTER //
// src/icons/Luminoso2cIcon.vue